module.exports = __webpack_public_path__ + "media/images/icons/arrow-circle-right-9728868dcb6ebb9b6516c84f9dff2f2d.svg";